import productAPI from '@/services/API/product'
import systemAPI from '@/services/API/system'

import { Message } from 'element-ui';

const fetchPreviousPage = function({commit, state, dispatch}) {
  if (state.page > 1) {
    commit('SET_PAGE', state.page - 1);
    dispatch('invalidateList');
    dispatch('fetchProducts');
  }
}

const fetchNextPage = function({commit, state, dispatch}) {
  if (state.page < state.pages) {
    commit('SET_PAGE', state.page + 1);
    dispatch('invalidateList');
    dispatch('fetchProducts');
  }
}

//Fetch customer based on a search string
const fetchProducts = function({ commit , state, dispatch, rootState}, fetchParams) {
  let params = {};
  if (fetchParams != null) {
    params = fetchParams;
  }

  params.searchTerms = _.trim(state.searchTerms);

  if (state.origin === 'CMS') {
    params.published = state.productFilters.cmsProducPublishedInd;
    params.active = state.productFilters.cmsActive;
    params.tags = state.productFilters.cmsCheckedTags;
  } else {
    params.published = state.productFilters.producPublishedInd;
    params.active = state.productFilters.active;
    params.tags = state.productFilters.checkedTags;
  }

  params.limit = state.limit;
  params.page = state.page;

  params.itemTypes = [];
  _.forEach(state.productFilters.checkedItemTypes, ct=>{
   params.itemTypes.push(ct);
  })
  params.itemTaxables = [];
  _.forEach(state.productFilters.checkedItemTaxables, ct=>{
   params.itemTaxables.push(ct);
  })
  params.itemActives = [];
  _.forEach(state.productFilters.checkedItemActives, ct=>{
   params.itemActives.push(ct);
  })

  if(params.page==0)params.page=1;

  params.summary = true;

  let xPortausInclude = [];
  if (state.extendedObjects.length > 0) {
    xPortausInclude = state.extendedObjects;
  }

  if(state.outDated || _.isEmpty(state.products)){

    commit('SET_LOADING', true);

    productAPI.listProductDefinitionV2(params, xPortausInclude, {complete: true})
      .then(data=>{
        if(data.list){
          commit('UPDATE_LIST', data.list);
        }else{
          commit('UPDATE_LIST', data);
        }

        if(data.count){
          commit('SET_COUNT', data.count );
          commit('SET_PAGES', data.pages );
          commit('SET_PAGE', data.page);
        }
        commit('SET_LOADING', false);

      })


  }
};

const createProduct = function ({commit, dispatch}, productToCreate){
  productToCreate.sku = _.trim(productToCreate.sku);
  return productAPI.createProductV2(productToCreate)
    .then(productCreated=>{
      dispatch('invalidateList');
      dispatch('fetchProducts');
      return productCreated;
    })
    .catch((err) => {
      if (err.response.status === 409) {
        // erreur de slug
        Message.error(`Le champs slug n'est pas unique. Veuillez spécifier une nouvelle valeur.`);
      } else {
          throw err;
      }
    })
}

const deleteProduct = function ({commit, dispatch}, productIdToDelete){
  return productAPI.deleteProduct(productIdToDelete)
    .then(()=>{
      dispatch('invalidateList');
      dispatch('fetchProducts');
      return true;
    })
}

const updateProduct = function ({commit, dispatch}, { productToUpdate, extendedObjects }){

  if (productToUpdate.image === undefined) {
    productToUpdate.image = null;
  }
 productToUpdate.sku = _.trim(productToUpdate.sku);


  return productAPI.updateProductV2(productToUpdate.id, productToUpdate, extendedObjects)
    .then(productUpdated=>{
      dispatch('invalidateList');
      dispatch('fetchProducts');
      return productUpdated;
    })
}

const deactivateProduct = function ({commit, dispatch}, productIdToDeactivate){
  let productToDeactivate = {};
  productToDeactivate.id = productIdToDeactivate;
  productToDeactivate.active = false;
  return productAPI.updateProduct(productToDeactivate)
    .then(productUpdated=>{
      dispatch('invalidateList');
      dispatch('fetchProducts');
      return productUpdated;
    })
}

const getProductsStats = function({commit, state}){
  if(state.statsOutdated){
    commit('SET_STATS_LOADING', true);
    productAPI.getStats()
      .then(stats=>{
        commit('UPDATE_STATS', stats);
        commit('SET_STATS_LOADING', false);
      })
  }
}

const setCheckedItemTypes = function({commit, dispatch}, val){
  commit('SET_CHECKED_ITEM_TYPES',val);
  dispatch('invalidateList');
  dispatch('fetchProducts');
}

const setCMSCheckedItemTypes = function({commit, dispatch}, val){
  commit('SET_CMS_CHECKED_ITEM_TYPES',val);
  dispatch('invalidateList');
  dispatch('fetchProducts');
}

const setCheckedItemTaxables = function({commit, dispatch}, val){
  commit('SET_CHECKED_ITEM_TAXABLE',val);
  dispatch('invalidateList');
  dispatch('fetchProducts');
}

const setCheckedItemActives = function({commit, dispatch}, val){
  commit('SET_CHECKED_ITEM_ACTIVES',val);
  dispatch('invalidateList');
  dispatch('fetchProducts');
}

let searchTimeOut = null;
const setSearchTerms = function({commit, dispatch}, { searchTerms, params }) {
  commit('SET_SEARCH_TERMS',searchTerms);
  clearTimeout(searchTimeOut)
  searchTimeOut = setTimeout(() => {
    commit('SET_PAGE', 1);
    dispatch('invalidateList');
    return dispatch('fetchProducts', params);
  }, 300)

}

const invalidateList = function ({ commit }) {
  commit('INVALIDATE_LIST');
}


const changePage = function({commit, dispatch}, page) {
  commit('SET_PAGE', page);
  dispatch('invalidateList');
  dispatch('fetchProducts')
}

const fetchTags = function({commit, state}){
  systemAPI.getTags('PRODUCT')
    .then(listTags=>{
      commit('SET_LIST_TAGS',listTags);
    })
}

const setExtendedObject = function({ commit }, extendedObjects) {
  commit('SET_EXTENDED_OBJECTS', extendedObjects);
}

const setProductPublishedInd = function({commit, dispatch, state}, publishedInd){
  let ind = null;
  if (publishedInd === '1') {
    ind = true;
  } if (publishedInd === '0') {
    ind = false;
  }
  if (state.origin === 'CMS') {
    commit('SET_CMS_PRODUCT_PUBLISHED_IND',ind);
  } else {
    commit('SET_PRODUCT_PUBLISHED_IND',ind);
  }

  dispatch('invalidateList');
  dispatch('fetchProducts');
}


const setActiveFilter = function({ commit, state, dispatch}, active) {
  let ind = null;
  if (active === '1') {
    ind = true;
  } if (active === '0') {
    ind = false;
  }
  if (state.origin === 'CMS') {
    commit('SET_CMS_ACTIVE_FILTER', ind);
  } else {
    commit('SET_ACTIVE_FILTER', ind);
  }
  dispatch('invalidateList');
  dispatch('fetchProducts');
}


const setOrigin= function({ commit }, origin) {
  commit('SET_ORIGIN', origin);
}

const setCheckedProductsTags = function({commit, dispatch, state}, tags){
  if (state.origin === 'CMS') {
    commit('SET_CMS_CHECKED_TAGS', tags);
  } else {
    commit('SET_CHECKED_TAGS', tags);
  }
  dispatch('invalidateList');
  dispatch('fetchProducts');
}


const resetProductFilters = function({commit, dispatch, state}, event){
  if(event != null) {
    event.stopPropagation();
  }
  if (state.origin === 'CMS') {
    commit('RESET_CMS_FILTERS');
  } else {
    commit('RESET_FILTERS');
  }

  dispatch('invalidateList');
  dispatch('fetchProducts');
}


export default {
  resetProductFilters,
  fetchProducts,
  changePage,
  invalidateList,
  setSearchTerms,
  getProductsStats,
  setCheckedItemTypes,
  setCheckedItemTaxables,
  setCheckedItemActives,
  createProduct,
  deleteProduct,
  updateProduct,
  deactivateProduct,
  fetchTags,
  fetchPreviousPage,
  fetchNextPage,
  setExtendedObject,
  setProductPublishedInd,
  setActiveFilter,
  setCheckedProductsTags,
  setOrigin,
};
